<template>
  <div>
    <div class="dropdown">
      <button class="btn btn-secondary dropdown-toggle btn-sm click btn-toggle-custom" type="button">
        Show Columns
      </button>
      <div class="muliple-select-custom showup">
        <ul>
          <li v-for="(item, index) in columns" :key="index">
            <div class="form-check" style="padding-left: 0.6em !important; padding-right: 0.6em !important">
              <input
                class="form-check-input"
                type="checkbox"
                :id="item.value"
                :value="item.value"
                :checked="index === 0 ? isCheckedAll : columnChecked.includes(item.value)"
                @click="index === 0 ? checkAll() : checkItem(item.value)"
              >
              <label class="form-check-label" :for="item.value">
                {{ item.label }}
              </label>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import "@vueform/multiselect/themes/default.css";
import $ from "jquery";

export default {
  name: "ShowHideColumnCustom",
  props: {
    columns: {
      type: Array,
      required: true,
    },
    changeCheckbox: {
      type: Function,
      default: () => {},
    },
    columnCheckedCache: {
      type: Array,
      required: true,
    },
    isInventory: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columnChecked: [],
      isCheckedAll: false,
    };
  },
  mounted() {
    this.initializeColumns();
    this.initializeDropdown();
  },
  methods: {
    initializeColumns() {
      if (this.isInventory) {
        this.columnChecked = this.columnCheckedCache;
        this.isCheckedAll = false;
      } else {
        if (!this.columnCheckedCache?.length) {
          this.$nextTick(() => {
            $(".muliple-select-custom #all").click();
          });
        } else {
          this.columnChecked = [...this.columnCheckedCache];
          this.checkAllStatus();
        }
      }
    },
    initializeDropdown() {
      $('.click').on('click', (event) => {
        event.stopPropagation();
        $(".showup").slideToggle("fast");
      });

      $(".showup").on("click", (event) => {
        event.stopPropagation();
      });

      $(document).on("click", () => {
        $(".showup").hide();
      });
    },
    checkAll() {
      this.columnChecked = [];

      if (!this.isCheckedAll) {
        this.columnChecked = this.columns
          .filter((item, index) => index !== 0 && item.value !== 'all')
          .map((item) => item.value);
      }

      this.checkAllStatus();
    },
    checkItem(columnValue) {
      const index = this.columnChecked.indexOf(columnValue);
      if (index > -1) {
        this.columnChecked.splice(index, 1);
      } else {
        this.columnChecked.push(columnValue);
      }
      this.checkAllStatus();
    },
    checkAllStatus() {
      this.isCheckedAll = this.columns.every((item, index) =>
        index === 0 || this.columnChecked.includes(item.value)
      );
      this.changeCheckbox(this.columnChecked);
    },
  },
};
</script>

<style scoped>
.btn-toggle-custom {
  margin-bottom: 0.5rem;
}

.muliple-select-custom {
  background-color: #FFFFFF;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%), 0 4px 6px -2px rgb(0 0 0 / 5%);
  border-radius: 0.375rem;
  position: absolute;
  z-index: 1000000 !important;
}

.showup {
  display: none;
}

.muliple-select-custom ul {
  list-style: none;
  padding-left: 0rem;
}

.muliple-select-custom {
  background-color: #FFFFFF;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%), 0 4px 6px -2px rgb(0 0 0 / 5%);
  border-radius: 0.375rem;
  position: absolute;
  z-index: 1000000 !important;

  max-height: 500px;
  overflow-y: auto;
}
</style>
